import React, { useEffect, useRef, useState } from 'react';
import { UnityWorld } from './UnityWorld';
import { FaPlay, FaPause, FaInfinity } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { setUnityConveyorBeltContinuousMode } from '../../redux/actions/unity';
import { registerEvents, requestInferenceBatch } from './unity_api';
import { ToolTipWrapper, ToolTip } from '../../components/Tooltip';
import { ObjectivePanel } from "../ObjectivesPanel/ObjectivesPanel";

var UnityConveyorBelt = function UnityConveyorBelt() {
  var tooltipRef = useRef(null);
  useEffect(registerEvents);

  var _useSelector = useSelector(function (state) {
    return state.unityConveyorBelt;
  }),
      unityAwake = _useSelector.unityAwake,
      continuousMode = _useSelector.continuousMode,
      waitingForScore = _useSelector.waitingForScore,
      content = _useSelector.content;

  var dispatch = useDispatch();
  var readyForOneShots = !waitingForScore && unityAwake && !continuousMode;
  var readyForContinuousMode = unityAwake && !waitingForScore;

  var handleStartContinuousMode = function handleStartContinuousMode(enabled) {
    if (enabled) {
      if (!readyForContinuousMode) {
        return;
      }

      requestInferenceBatch();
    }

    dispatch(setUnityConveyorBeltContinuousMode(enabled));
  };

  var handleOneShot = function handleOneShot() {
    if (readyForOneShots) {
      requestInferenceBatch();
    }
  }; // const isCompletedStateClass = () => {
  //   return game.completed ? "panel--round__header green" : "panel--round__header";
  // }


  return /*#__PURE__*/React.createElement("div", {
    className: "flex-column-container conveyor-belt panel--round"
  }, /*#__PURE__*/React.createElement("div", {
    className: "conveyor-belt__controls clearfix"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "no-margin"
  }, "Conveyor Belt Controls"), /*#__PURE__*/React.createElement("div", {
    className: "flex-row-container flex-justify-center"
  }, /*#__PURE__*/React.createElement(ToolTipWrapper, {
    reference: tooltipRef,
    message: "single batch"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleOneShot,
    className: "conveyor-belt__controls_btn".concat(readyForOneShots ? '' : '__disabled')
  }, /*#__PURE__*/React.createElement(FaPlay, null), " 1")), !continuousMode ? /*#__PURE__*/React.createElement(ToolTipWrapper, {
    reference: tooltipRef,
    message: "start continuous mode"
  }, /*#__PURE__*/React.createElement("button", {
    className: "conveyor-belt__controls_btn".concat(readyForContinuousMode ? '' : '__disabled'),
    onClick: function onClick() {
      handleStartContinuousMode(true);
    }
  }, /*#__PURE__*/React.createElement(FaPlay, null), " ", /*#__PURE__*/React.createElement(FaInfinity, null))) : /*#__PURE__*/React.createElement(ToolTipWrapper, {
    reference: tooltipRef,
    message: "pause continuous mode"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      handleStartContinuousMode();
    },
    className: "conveyor-belt__controls_btn"
  }, /*#__PURE__*/React.createElement(FaPause, null))))), /*#__PURE__*/React.createElement(UnityWorld, {
    url: "https://cs2n-unity-games.s3.amazonaws.com",
    build: "001_08-06-1056"
  }), /*#__PURE__*/React.createElement(ToolTip, {
    ref: tooltipRef
  }), /*#__PURE__*/React.createElement(ObjectivePanel, null));
};

export default UnityConveyorBelt;